import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useOrgNotificationsSocket } from '../../../../shared/sockets';
import { interveneChatCountsAtom, interveneFilterAtom } from '../../state/interveneAtoms';
import { NOTIFICATION_TYPES, SOCKET_EVENTS } from '../constants/socketEvents';
import { normalizeInterveneSocketPayload } from '../parseIntervenePayload';
import { createHandleCountsUpdated } from '../handlers/handleCountsUpdated';
import { interveneSocketConnectionAtom } from '../state/socketAtoms';

export function useInterveneOrgNotificationsBridge(routePayload) {
  const { subscribe, connectionStatus } = useOrgNotificationsSocket();
  const setChatCounts = useSetRecoilState(interveneChatCountsAtom);
  const filters = useRecoilValue(interveneFilterAtom);
  const setSocketConnection = useSetRecoilState(interveneSocketConnectionAtom);

  useEffect(() => {
    setSocketConnection((prev) => ({
      ...prev,
      notificationsBridge: connectionStatus,
    }));
  }, [connectionStatus, setSocketConnection]);

  useEffect(() => {
    const handleCounts = createHandleCountsUpdated({
      setChatCounts,
      getBotNumber: () => filters.botNumber,
    });

    return subscribe((payload) => {
      const normalized = normalizeInterveneSocketPayload(payload);
      if (!normalized) return;

      if (normalized.type === SOCKET_EVENTS.COUNTS_UPDATED) {
        handleCounts(normalized.data);
        return;
      }

      if (
        normalized.kind === 'notification' &&
        normalized.type === NOTIFICATION_TYPES.QUEUE_COUNTS
      ) {
        handleCounts(normalized.data);
        return;
      }

      if (normalized.type === SOCKET_EVENTS.LIST_UPDATED) {
        routePayload?.(payload);
        return;
      }

      if (normalized.type === SOCKET_EVENTS.CHAT_MESSAGE) {
        routePayload?.(payload);
        return;
      }

      routePayload?.(payload);
    });
  }, [subscribe, setChatCounts, filters.botNumber, routePayload]);
}
